<template>
  <div class="text-page">
    <Breadcrumbs :links="breadCrumbsLinks"/>
    <div class="container">
      <div class="container-inner">
        <h1 class="text-page__title">{{$tSiteMap('Site map')}}</h1>
        <div class="text-page__content">
          <BasePreloader v-if="pending"/>
          <div v-else class="text">
            <SiteMapList :value="list"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {http} from '../axios';
  import globalMetaMixin from '../mixins/globalMetaMixin'
  import Breadcrumbs from '../components/Breadcrumbs'
  import SiteMapList from '../components/SiteMapList'

  export default {
    mixins: [globalMetaMixin],
    components: {
      Breadcrumbs,
      SiteMapList
    },
    data() {
      return {
        pending: false,
        list: []
      };
    },
    computed: {
      newsSlug() {
        return this.$route.params.newsSlug
      },
      breadCrumbsLinks() {
        return [{
          name: this.$tSiteMap('Site map'),
        }]
      }
    },
    methods: {
      load() {
        this.pending = true

        return http.get(`/api/helper/html-sitemap`).then(({data}) => {
          this.list = data.data

          const title = this.$tMeta('site-map-meta-title')
          const description = this.$tMeta('site-map-meta-description')
          
          this.setMetaTitleMixin(title)
          this.setMetaDescriptionMixin(description)
          this.setOpenGraph({
            title,
            description,
          })
        }).finally(() => {
          this.pending = false
        })
      }
    },
    created() {
      this.load()
    },
    watch: {
      $route() {
        this.load()
      }
    }
  }
</script>

<style>


</style>

